// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lzfsl{height:80px}.j_Io0{display:flex;flex-direction:column;gap:16px;margin-bottom:-16px}.vqVM8{overflow:visible !important;overflow-x:visible !important;overflow-y:visible !important}.vqVM8>div{overflow:visible !important;overflow-x:visible !important;overflow-y:visible !important}.P4NOU{display:flex;align-items:center;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agreementName": `Lzfsl`,
	"effectiveDate": `j_Io0`,
	"effectiveDateModalBody": `vqVM8`,
	"scheduledTooltip": `P4NOU`
};
export default ___CSS_LOADER_EXPORT___;
